<template>
  <div @click="$emit('click')" class="gallery">
    <div
      class="grid-equalHeight-noBottom"
    >
      <div
        v-if="Object.keys(data.gallery).length > 1"
        class="col-2 sm-hidden"
      >
        <ul class="gallery__thumbnails" data-glide-el="controls[nav]">
          <li
            v-for="(slide, key, index) in data.gallery"
            :key="index"
            class="gallery__thumbnail"
            :class="{ '--is-gif': slide.photos['b2c' || 'b2b'].mime_type === 'image/gif' }"
            :data-glide-dir="`=${index}`"
            @click="glide.pause()"
          >
            <slot v-if="slide.photos['b2c' || 'b2b'].mime_type === 'image/gif'">
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
              >
            </slot>

            <slot v-else>
              <img
                v-if="$store.getters.isB2b && slide.photos['b2b'].original"
                :src="`${slide.photos['b2b'].original}?format=${webPFormat('png')}&width=80&lossless`"
                fetchpriority="high"
              >

              <img
                v-else
                :src="`${slide.photos['b2c'].original}?format=${webPFormat('png')}&width=80`"
                fetchpriority="high"
              >
            </slot>
          </li>
        </ul>
      </div>

      <div
        :class="{ 'col-11_sm-12': Object.keys(data.gallery).length == 1, 'col-10_sm-12': Object.keys(data.gallery).length > 1 }"
      >
        <div ref="glide" class="glide">
          <div class="glide__track" data-glide-el="track">
            <ul class="glide__slides">
              <li
                v-for="(slide, key, index) in data.gallery"
                :key="index"
                class="glide__slide"
              >
                <div class="gallery__media-wrapper">
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" class="gallery__stretcher">

                  <slot v-if="slide.photos['b2c' || 'b2b'].mime_type === 'image/gif'">
                    <video
                      v-if="!$store.getters.getBrowser.getBrowserName().match(/safar/gi)"
                      class="gallery__media"
                      :class="{ '--is-shrinked' : slide.photos.b2c.shrink }"
                      muted
                      loop
                    >
                      <source
                        v-if="(!$store.getters.isB2b && slide.photos.b2c.original) || ($store.getters.isB2b && !slide.photos.b2b.original)"
                        :src="slide.photos.b2c['original'].replace('.gif', '.webm')"
                        type="video/webm"
                      >

                      <source
                        v-if="($store.getters.isB2b && slide.photos.b2b.original) || (!$store.getters.isB2b && !slide.photos.b2c.original)"
                        :src="slide.photos.b2b['original'].replace('.gif', '.webm')"
                        type="video/webm"
                      >
                    </video>

                    <img
                      v-else
                      :src="$store.getters.isB2b ? slide.photos.b2b['original'] : slide.photos.b2c['original']"
                      :alt="`${data.name} Präsent Box Bilder`"
                      class="gallery__media"
                      :class="{ '--is-shrinked' : slide.photos.b2c.shrink }"
                      fetchpriority="low"
                    >
                  </slot>

                  <slot v-else>
                    <img
                      v-if="(!$store.getters.isB2b && slide.photos.b2c.original) || ($store.getters.isB2b && !slide.photos.b2b.original)"
                      :srcset="`
                        ${slide.photos.b2c['original']}?format=${webPFormat('png')}&width=1200&quality=80&alphaquality=30 1200w,
                        ${slide.photos.b2c['original']}?format=${webPFormat('png')}&width=768&quality=80&alphaquality=30 768w
                      `"
                      :sizes="
                        slide.photos.b2c.shrink ?
                        `(max-width: 33em) 70vw,
                        29em`
                        :
                        `(max-width: 26em) 90vw,
                        29em`
                      "
                      :src="`${slide.photos.b2c['original']}?format=${webPFormat('png')}&width=768&lossless=1`"
                      :alt="`${data.name} Präsent Box Bilder B2C`"
                      class="gallery__media"
                      :class="{ '--is-shrinked' : slide.photos.b2c.shrink }"
                      fetchpriority="high"
                    >

                    <img
                      v-if="($store.getters.isB2b && slide.photos.b2b.original) || (!$store.getters.isB2b && !slide.photos.b2c.original)"
                      :srcset="`
                        ${slide.photos.b2b['original']}?format=${webPFormat('png')}&width=1200&quality=80&alphaquality=30 1200w,
                        ${slide.photos.b2b['original']}?format=${webPFormat('png')}&width=768&quality=80&alphaquality=30 768w
                      `"
                      :sizes="
                        slide.photos.b2b.shrink ?
                        `(max-width: 33em) 70vw,
                        29em`
                        :
                        `(max-width: 26em) 90vw,
                        29em`
                      "
                      :src="`${slide.photos.b2b['original']}?format=${webPFormat('png')}&width=768&quality=80&alphaquality=30`"
                      :alt="`${data.name} Präsent Box Bilder B2B`"
                      class="gallery__media"
                      :class="{ '--is-shrinked' : slide.photos.b2b.shrink }"
                      fetchpriority="high"
                    >
                  </slot>
                </div>

                <ul class="gallery__features" v-if="slide.features && Object.keys(slide.features[customerType]).length">
                  <li
                    v-for="(feature, index) in slide.features[customerType]"
                    :key="index"
                    class="gallery__feature"
                  >
                    <span v-html="feature.icon"></span>

                    {{ feature.title }}
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <div class="gallery__controls" data-glide-el="controls">
            <button type="button" data-glide-dir="<" @click="glide.pause()"><i class="icon icon-angle-left"></i></button>
            <button type="button" data-glide-dir=">" @click="glide.pause()"><i class="icon icon-angle-right"></i></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Glide from '@glidejs/glide';

import { helperMixin } from '@/mixins/HelperMixin';

export default {
  name: 'Gallery',
  mixins: [helperMixin],
  props: {
    data: {
      type: Object
    }
  },
  components: {
    // Section,
  },
  data () {
    return {
      glide: null,
      options: {
        type: 'slider',
        autoplay: process.env.NODE_ENV === 'development' ? false : 5000,
        hoverpause: false,
        startAt: 0,
        perView: 1,
        gap: 0,
        bound: true,
        classes: {
          nav: {
            active: '--is-active'
          }
        }
      }
    };
  },
  methods: {
    stop (goToSlide) {
      if (goToSlide) {
        this.glide.go(`=${goToSlide - 1}`);
      }

      this.glide.pause();
    }
  },
  computed: {
    customerType () {
      return this.$store.getters.isB2b ? 'b2b' : 'b2c';
    }
  },
  mounted () {
    this.glide = new Glide(this.$el, this.options);
    this.glide.mount();
    this.glide.on('run.after', () => {
      const video = this.$el.querySelector('.glide__slide--active video');

      if (video) {
        video.play();
      }
    });
  },
  destroyed () {
    if (this.glide) {
      this.glide.destroy();
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@glidejs/glide/src/assets/sass/glide.core';

/**
 * Gallery
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Photo gallery for the present landing page
 * @since 2022-04-08
**/

$component: 'gallery';

.#{$component} {
  > [class^='grid'] {
    height: 100%;
  }

  &__thumbnails {
    @include unlist;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &__thumbnail {
    position: relative;
    width: 100%;
    height: auto;
    // aspect-ratio: 1 / 1;
    @include padding(map-get($spacers, 2));
    border: 1px solid rgba($white, 0.5);
    border-radius: $border-radius-lg;
    background: rgba($white, 0.3);
    cursor: pointer;

    & + & {
      @include margin-top(map-get($spacers, 3));
    }

    @include hover () {
      background: rgba($white, 0.5);
    }

    &:active {
      background: rgba($white, 0.4);
    }

    > img {
      @include imageRendering;
      display: block;
      width: 100%;
      height: auto;
    }

    &.--is-active {
      border-color: $white;
      background: rgba($white, 0.5);
    }

    &.--is-video,
    &.--is-gif {
      &:before,
      &:after {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        right: 0;
        margin: 0 auto;
      }

      &:before {
        top: calc(50% - 20px);
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: rgba($white, 0.9);
      }

      &:after {
        width: 0px;
        height: 0px;
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;
        border-left: 10px solid $ink;
        border-radius: 10px;
        top: calc(50% - 10px);
      }
    }
  }

  &__media-wrapper {
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
    height: auto;
    margin: 0 auto;
    aspect-ratio: 1 / 1;
  }

  &__stretcher {
    display: block;
    width: 100%;
    height: auto;
  }

  &__media {
    @include imageRendering;
    position: absolute;
    width: 100%;
    aspect-ratio: 1 / 1;
    margin: 0 auto;

    &.--is-shrinked {
      width: 78%;
    }

    @keyframes loadingImage {
      0% { opacity: 1; }
      50% { opacity: 0.6; }
      100% { opacity: 1; }
    }
  }

  &__features {
    @include unlist;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    color: $white;
  }

  &__feature {
    display: flex;
    align-items: center;
    width: 46%;

    > span {
      @include rfs(2.6rem, width);
      height: auto;
      flex-shrink: 0;
      @include margin-right(map-get($spacers, 3));
    }
  }

  &__controls {
    display: flex;
    align-items: center;
    position: absolute;
    top: 50%;
    width: 100%;
    justify-content: space-between;
    pointer-events: none;
    transform: translateY(-50%);

    button {
      margin: 0;
      padding: 0;
      border: 0;
      outline: none;
      background: none;
      color: $white;
      @include font-size($font-size-lg * 5);
      line-height: 1;
      text-shadow: 1px 1px 0 rgba($ink, 0.5);
      opacity: 0.6;
      pointer-events: all;

      @include hover () {
        opacity: 1;
      }

      &:first-child {
        @include margin-left(- map-get($spacers, 5));
      }

      &:last-child {
        @include margin-right(- map-get($spacers, 5));
      }
    }
  }

  /* Glide */
  .glide {
    display: block;

    &__slides {
      display: flex;
      margin: 0;
    }

    &__slide {
      width: 100%;
      height: auto;
    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
    &__controls button {
      @include font-size($font-size-lg * 8);
    }
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
    &__features {
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    &__feature {
      width: 100%;

      & + & {
        @include margin-top(map-get($spacers, 3));
      }
    }
  }

  // ——————————————————————————————
  // Special breakpoints for Height
  // ——————————————————————————————
  // For short screen resolutions in desktop
  @media (max-height: 670px) and (min-width: map-get($landing-page, 'viewport-lg')) {
    &__thumbnail {
      width: 76%;
    }

    &__media-wrapper {
      width: 76%;
    }
  }

}
</style>
